export default {
  // variaveis de login
  usuario: {
    codUsuario: null,
    desLogin: null,
    nomUsuario: null,
    accessToken: null
  }
}
